// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
// import Vconsole from 'vconsole'
import VueClipboards from 'vue-clipboards'
import {
  Toast
} from 'wc-messagebox'
import 'wc-messagebox/style.css'
Vue.use(VueClipboards)
Vue.use(Toast, {
  location: 'center',
  duration: '1800'
})
Vue.config.productionTip = false
// let vConsole = new Vconsole()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/pages/member-share/member-share.js